<template>
  <div class="login u-containar-md">
    <HeadingLv2 text="パスワードの再設定完了" simple />
    <section>
      <div class="text_area">
        <TextBlock>
          <p class="resetComplete_heading">
            パスワードの設定が<br />完了しました。
          </p>
          <ul class="notes">
            <li>
              新しく再設定したパスワードでログインしてご利用ください。
            </li>
          </ul>
        </TextBlock>
      </div>
    </section>

    <section>
      <div class="reset">
        <Button
          href="/login"
          label="ログイン"
          :handleClick="
            () => {
              $router.push('/login')
            }
          "
          primary
          border
          wide303
        />
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import smoothscroll from 'smoothscroll-polyfill'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import Button from '@/components/elements/Button.vue'
import HrBlock from '@/components/elements/HrBlock.vue'
import { onMounted, computed, SetupContext, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { applyValidation } from '@/utils/validation'
import axios from 'axios'

export default {
  name: 'ResetComplete',

  setup(props: any) {
    const store = useStore()
    const router = useRouter()

    console.log('store', store.state)
    if (store.state.isPasswordResetToken != true) {
      router.push('/')
    }

    store.commit('setPasswordResetToken', false)
  },
  components: {
    HeadingLv2,
    Button
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.text_area {
  margin-bottom: 15px;
}

.resetComplete_heading {
  font-size: 2.2rem;
  line-height: 1.5;
  text-align: center;
  color: var.$color-main-text;

  & + p {
    margin-top: 14px;
  }
  & + ul {
    margin-top: 14px;
  }
}
</style>
